var map = {
	"./adult/nn/ordforstaelse-data.json": 832,
	"./adult/no/ordforstaelse-data.json": 833,
	"./child/de/ordforstaelse-data.json": 834,
	"./youth/de/ordforstaelse-data.json": 835,
	"./youth/nn/ordforstaelse-data.json": 836,
	"./youth/no/ordforstaelse-data.json": 837,
	"./youth/se/ordforstaelse-data.json": 838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;